import moment from "moment-timezone"

export const getCurrentUSCentralUnixTime = (): number => {
  return moment().tz(`America/Chicago`).unix()
}
